module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level4.3441d211.png";